<template lang="pug">
  div
    router-view
</template>
<script>
export default {
  name: 'ManageVoucher',
}
</script>